export const LAB_ORDER_DRAWER_PROTOCOL_MUTATION_CACHE_KEY = 'lab-order-drawer';
